"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIUserResponseSchema = void 0;
const zod_1 = require("zod");
const onboarding_1 = require("../constants/onboarding");
// ===== SCHEMAS =====
exports.APIUserResponseSchema = zod_1.z.object({
    id: zod_1.z.string().nullish(),
    firstName: zod_1.z.string().nullish(),
    lastName: zod_1.z.string().nullish(),
    birthday: zod_1.z.string().nullish(),
    timezoneId: zod_1.z.string().nullish(),
    countryCode: zod_1.z.string().nullish(),
    // Location fields
    city: zod_1.z.string().nullish(),
    stateRegion: zod_1.z.string().nullish(),
    countryName: zod_1.z.string().nullish(),
    latitude: zod_1.z.number().nullish(),
    longitude: zod_1.z.number().nullish(),
    // Onboarding
    onboardingIntent: zod_1.z.enum(onboarding_1.ONBOARDING_INTENT_VALUES).nullish(),
    // Timestamps
    completedAt: zod_1.z.date().nullish(),
    createdAt: zod_1.z.date().nullish(),
    updatedAt: zod_1.z.date().nullish(),
});
//# sourceMappingURL=user.js.map